@if (isLoading) {
<div>
  <i class="pi pi-spin pi-spinner" style="font-size: 3em"></i>Loading...
</div>
}

@if (errorMessage) {
<div><p-message severity="error" [text]="errorMessage"></p-message></div>
}

@if (workOrder) {
<form id="workOrderForm" #workOrderForm="ngForm" class="container">
  <div class="row iPhoneFix no-gutter container">
    <div class="col-12 no-gutter container">
      <div class="row no-gutter">
        <div class="col-6 no-gutter">
          <h4>Tree Work Order Maintenance</h4>
        </div>
      </div>
      <br>
      <!-- Common top section includes basic WO information such as customer, address, representative -->
      <app-work-order-maintenance-common-fields-top [(workOrder)]="workOrder" [isEditable]="isEditable"
        [isCustomer]="isCustomer">
      </app-work-order-maintenance-common-fields-top>
      @if (canReassignRM) {
      <div class="row">
        <div class="p-col-12 p-lg-6">
          <div class="bold">
            Regional Manager
          </div>
          @if (workOrder) {
          <ng-select class="custom" required [searchable]="false" [selectOnTab]="true" [items]="rms"
            placeholder="Select a Regional Manager" name="rep" bindLabel="fullName"
            [(ngModel)]="workOrder.representative" (ngModelChange)="repChanged()" [disabled]="!isEditable || !changeRM">
          </ng-select>
          }
        </div>
      </div>
      }
      @if (workOrder && workOrder.customer && workOrder.customer.customerComments && !isCustomer) {
      <div class="p-col-12 p-md-2">
        @if (workOrder && workOrder.id && workOrder.completionStatus != 'Completed' && workOrder.completionStatus
        !='Unable to be Completed' && !isCustomer && isAdminOrForeman) {
        <p-button type="button" class=" smallButton" (click)="onMyWay()" [disabled]="false" label="On My Way" fluid severity="info">
        </p-button>
        }
        @if (!isCustomer) {
        <span class="fine-print" style="text-align: right;">
          Last Sent: {{workOrder.onMyWaLastSent ? (workOrder.onMyWaLastSent | date: 'short') : 'Not Sent'}} 
        </span>
        }
        &nbsp;
        @if (workOrder && workOrder.id && workOrder.completionStatus != 'Completed' && workOrder.completionStatus
        !='Unable to be Completed' && !isCustomer && isAdminOrForeman) {
        <p-button type="button" class=" smallButton" severity="warn" (click)="wrappingUp()" [disabled]="false" fluid
          label="Wrapping Up">
        </p-button>
        }
        @if (!isCustomer) {
        <span class="fine-print" style="text-align: right;">
          Last Sent: {{workOrder.wrappingUpLastSent ? (workOrder.wrappingUpLastSent | date: 'short') : 'Not Sent'}}
        </span>
        }
      </div>
      }
      @if (workOrder && !isCustomer && workOrder.completionStatus == 'Completed') {
      <div>
        <p-button type="button" class=" smallButton" (click)="duplicateToQuote()" [disabled]="saving" severity="info"
          label="Duplicate Work Order to New Quote">
        </p-button>
      </div>
      }
      @if (!isCustomer) {
      <div class="row">
        <div class="col-12 p-md-6 multiselect">
          <h6>Required Skill(s)/Certification(s)</h6>
          @if (workOrder) {
          <p-multiselect autofocusFilter placeholder=" " [options]="requiredSkills" name="requiredSkills" [ngModel]="requiredSkills" [panelStyle]="{minWidth:'12em'}" fluid
            optionLabel="name" disabled defaultLabel="">
            <ng-template let-value pTemplate="selectedItems">
              @for (val of value; track val) {
              <div>
                <span>{{val.name}}</span>
              </div>
              }
              @if (!value || value.length === 0) {
              <span style="width: 150px;" class="ui-multiselected-empty-token ui-corner-all">No Skills Required</span>
              }
            </ng-template>
            <ng-template let-skill pTemplate="item">
              {{skill.label}}
            </ng-template>
          </p-multiselect>
          }
        </div>
        <div class="col-12 p-md-6 multiselect">
          <h6>Required Equipment</h6>
          @if (workOrder) {
          <p-multiselect autofocusFilter placeholder=" " [options]="requiredEquipment" name="requiredEquipment" [ngModel]="requiredEquipment" fluid
            [panelStyle]="{minWidth:'12em'}" optionLabel="type" disabled defaultLabel="">
            <ng-template let-value pTemplate="selectedItems">
              @for (val of value; track val) {
              <div>
                <span>{{val.type}}</span>
              </div>
              }
              @if (!value || value.length === 0) {
              <span style="width: 180px;" class="ui-multiselected-empty-token ui-corner-all">No Equipment Required</span>
              }
            </ng-template>
            <ng-template let-role pTemplate="item">
              {{role.label}}
            </ng-template>
          </p-multiselect>
          }
        </div>
      </div>
      }
      @if (!isCustomer) {
      <div class="row">
        <div class="col-12 p-md-2" style="text-align: left;">
          <p-button type="button" (click)="addNewWorkTask()" fluid class="smallButton"
            [disabled]="!isEditable && !canAddTaskToCompletedWO" label="Add Work Task"></p-button>
        </div>
      </div>
      }
      <br>
      @if (workOrder) {
      <div class="row">
        @for (wowt of workOrder.workOrderWorkTasks; track wowt) {
        <div class="col-12 col-md-6 col-lg-4">
          <app-work-order-maintenance-work-task-card [workOrderWorkTask]="wowt" [isEditable]="isEditable"
            [isCustomer]="isCustomer" [customerId]="workOrder.customer.id" [quoteNumber]="workOrder.quoteNumber"
            [hidePrice]="workOrder.hidePrice" (completeWorkTaskEvent)="completeTask($event)"
            (copyWorkTaskEvent)="copyWorkTask($event)" (deleteWorkTaskEvent)="deleteWorkTask($event)"
            (editWorkTaskEvent)="editWorkTask($event)"
            (unableToCompleteWorkTaskEvent)="unableToCompleteWorkTask($event)"
            (undoCompleteTask)="undoCompleteTask($event)">
          </app-work-order-maintenance-work-task-card>
        </div>
        }
      </div>
      }
      <div class="row">
        <div class="col-12">
          <div class="bold">Multi-Day Job: </div>
          @if (workOrder) {
          <p-radiobutton name="isMultiday" [value]="true" [(ngModel)]="workOrder.isMultiday"
            [disabled]="!isEditable" required>
          </p-radiobutton>
          <label for="isMultiday">Yes&nbsp;</label>
          }
          @if (workOrder) {
          <p-radiobutton name="isNotMultiday" [value]="false" [(ngModel)]="workOrder.isMultiday"
            [disabled]="!isEditable" required>
          </p-radiobutton>
          <label for="isNotMultiday">No</label>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h6 class="bold">Outside Expenses: </h6>
          @if (workOrder) {
          <p-radiobutton name="hasRentalExpense" [value]="true" [(ngModel)]="workOrder.hasRentalExpense"
            [disabled]="!isEditable && !canSaveAfterCompletion" required>
          </p-radiobutton>
          <label for="hasRentalExpense">Yes&nbsp;</label>
          }
          @if (workOrder) {
          <p-radiobutton name="noRentalExpense" [value]="false" [(ngModel)]="workOrder.hasRentalExpense"
            [disabled]="!isEditable && !canSaveAfterCompletion" required>
          </p-radiobutton>
          <label for="noRentalExpense">No</label>
          }
        </div>
        @if (workOrder?.hasRentalExpense) {
        <div class="col-12">
          <h6>Outside Cost(s)</h6>
          <p>
            <input pInputText name="rentalCosts" numeric [textMask]="{mask: currencyMask}"
              [(ngModel)]="workOrder.rentalCost" [required]="workOrder.hasRentalExpense"
              [disabled]="!isEditable && !canSaveAfterCompletion" (ngModelChange)="workOrder.rentalCost=$event" />
          </p>
          <h6>Describe Outside Cost(s)</h6>
          <div>
            <input pInputText name="rentalDescription" [(ngModel)]="workOrder.rentalDescription" fluid
              [required]="workOrder.hasRentalExpense" [disabled]="!isEditable && !canSaveAfterCompletion" />
          </div>
        </div>
        }
      </div>
      @if (workOrder && workOrder.quoteWorkOrder && !isCustomer) {
      <div class="row">
        <div class="col-12">
          <h6>Quote Uploads</h6>
          <app-blob-manager [angularUpload]="true" [containerName]="'quote'" [parentRecordId]="workOrder.quoteWorkOrder.id"
            [viewOnly]="true"></app-blob-manager>
        </div>
      </div>
      }
      @if (workOrder && !isCustomer) {
      <div class="row">
        <div class="col-12">
          <h6>Upload Photos of Work</h6>
          <app-blob-manager [angularUpload]="true" [containerName]="'work-work-order'" [parentRecordId]="workOrder.id"
            [uploadLabel]="'Document/Photo'" [viewOnly]="!canUpload || !canSave">
          </app-blob-manager>
        </div>
      </div>
      }
      @if (canCompleteATask && completeableTaskCount > 1) {
      <div style="width: 200px; padding-bottom: 3px;">
        <p-button fluid type="button" class="smallButton" label="Complete All Tasks" (click)="op1.toggle($event)"></p-button>
        <p-popover #op1 [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true">
          <div style="max-width: 500px">
            <form id="hoursEntry" #hoursEntry="ngForm" class="container">
              <p-message severity="info"
                text="**This completes all scheduled tasks**
                To complete all scheduled tasks enter the amount of time worked by each employee for the day and feedback. 
                That time will be split between the tasks and the feedback will be set on each task. 
                Example: If one employee works for 6 hours on that day on two tasks and another works for 4 hours on that day, enter 6 for the first employee and 4 for the second. 
                The first employee's time will be 3 hours on each task and the second employee's time will be 2 hours on each task.">
              </p-message>
              <h5>
                FEEDBACK ON JOB
              </h5>
              <textarea name="feedback" [rows]="5" [cols]="40" pInputTextarea [(ngModel)]="overallFeedback"
                required></textarea>
              <h5>
                HOURS ON THE JOB
              </h5>
              <div>
                Please submit to the quarter hour. Example: if employee worked 6 hrs & 15 minutes, input 6.25.
              </div>
              <div clas="continer">
                @for (taskHourEntry of hourEntries; track taskHourEntry) {
                <div class="row">
                  <div class="col-6">
                    <app-employee-card sytle="margin: auto; veritcal-align: middle" [employee]="taskHourEntry.employee"
                      [deleteable]="false"></app-employee-card>
                  </div>
                  <div class="col-6">
                    <input required type="text" pInputText [(ngModel)]="taskHourEntry.hours" fluid
                      (ngModelChange)="getHourTotal()"
                      [name]="taskHourEntry.id + '-' + taskHourEntry.employeeId + '-hours'" />
                  </div>
                </div>
                }
                @if (addingEmployee) {
                <div>
                  <ng-select class="custom" required [items]="employees" placeholder="Select an Employee"
                    [selectOnTab]="true" (ngModelChange)="addNewTaskHourEntry($event)" name="certifiedApplicator"
                    bindLabel="fullName" [(ngModel)]="selectedEmployee">
                  </ng-select>
                </div>
                }
              </div>
              <div class="row">
                <div class="col-6">
                  <p-button type="button" label="Add Employee" icon="pi pi-plus" class=" " fluid
                    (click)="addEmployee()"></p-button>
                </div>
                <div class="col-6" style="text-align: right;">
                  Total: {{totalHours}} hrs
                </div>
              </div>
              @if (verifyPrice) {
              <div>
                <h5>
                  CONFIRM PRICE
                </h5>
                <div>
                  Please input the final price of this task (not including tax). If needed, please consult with the
                  Regional Manager on the work order to ensure you are submitting the correct price. The price you input
                  below is what the customer will receive in their invoice.
                </div>
                @for (task of tasksToVerifyPrice; track task) {
                <div class="row">
                  <div class="col-6" style="margin: auto">
                    {{task.name}}
                  </div>
                  <div class="col-6">
                    @if (task) {
                    <input pInputText [name]="'price' + task.id" required numeric [textMask]="{mask: currencyMask}"
                      [(ngModel)]="task.price" />
                    }
                  </div>
                </div>
                }
              </div>
              }
              <p-button type="submit" label="Submit" (click)="completeAllIncompleteTasks(hoursEntry, op1);"
                severity="success" [disabled]="!canCompleteATask"></p-button>
            </form>
          </div>
        </p-popover>
      </div>
      }
      <div style="width: 200px;">
        @if (workOrder && workOrder.id && workOrder.completionStatus != WorkWorkOrderCompletionStatus.Completed &&
        workOrder.completionStatus != WorkWorkOrderCompletionStatus.Unable_to_be_Completed && !isCustomer) {
        <p-button fluid type="button" class=" smallButton disabledButton" (click)="completeWO()" [disabled]="!canCompleteWO" severity="info" label="Complete Work Order">
        </p-button>
        }
        @if (workOrder && workOrder.id && canUndoWOCompletion) {
        <p-button fluid type="button" class=" smallButton" (click)="openUndoWOCompletion()" severity="info"
          label="Undo Work Order Completion"></p-button>
        }
      </div>
      <!-- Common bottom section includes total information such as price adjustments, subtotal, sales tax, total -->
      @if (workOrder) {
      <app-work-order-maintenance-common-fields-bottom [(workOrder)]="workOrder" [(isEditable)]="isEditable"
        [isCustomer]="isCustomer" [canCompleteWO]="canCompleteWO" [hidePrice]="workOrder.hidePrice"
        (priceAdjustmentDeleted)="deletePriceAdjustment($event)">
      </app-work-order-maintenance-common-fields-bottom>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-1 columnPadding">
      @if (workOrderForm.invalid && workOrderForm.submitted) {
      <div class="alert alert-danger" role="alert">
        There are errors on this page. Please correct the errors and resubmit.
      </div>
      }
    </div>
    <div class="col-12" style="text-align: right;">
      @if (!canSave) {
      <p-button type="button" severity="warn" (click)="cancel('work')" label="Back">
      </p-button>
      }
      @if (canSave) {
      <p-button type="button" severity="warn" (click)="cancel('work')" [label]="isEditable ? 'Cancel ': 'Back'">
      </p-button>
      }
      @if (canSaveAfterCompletion) {
      <p-button type="button" severity="success" (click)="saveAfterCompletion()" [disabled]="saving" label="Save">
      </p-button>
      }
      @if (canSave && !isCustomer) {
      <p-button type="submit" severity="success" (click)="preSave(workOrderForm)" [disabled]="saving" label="Save">
      </p-button>
      }
    </div>
  </div>
</form>
}

<!-- Add New Work Task dialog -->
<!-- Only dialogs inside class scrollableDialog get the CSS for scrolling. Only use scrollableDialog if the dialog actually has enough content that
        it needs to scroll because it looks weird otherwise. -->
@if (displayWorkTaskDialog) {
<div class="scrollableDialog">
  <p-dialog header="Work Task Info" [(visible)]="displayWorkTaskDialog" [modal]="true" [resizable]="false" [breakpoints]="{'760px': '100vw'}"
    [baseZIndex]="10000" [maximizable]="true" [style]="{'width': '760px'}" [focusOnShow]="false"
    (onHide)="cancelledTask()" [closable]="true" (visibleChange)="cancelledTask()">
    <app-work-task-maintenance (timeToClose)="closedDialog($event)" (cancelled)="cancelledTask($event)"
      (delete)="deleteWorkTaskByTask($event)" [workOrder]="workOrder"
      [task]="selectedWorkTask"></app-work-task-maintenance>
  </p-dialog>
</div>
}


@if (showUndoCompleteDialog) {
<div>
  @if (showUndoCompleteDialog) {
  <p-dialog header="Undo Work Order Completion" [(visible)]="showUndoCompleteDialog" [modal]="true" [resizable]="false"
    [baseZIndex]="10000" appendTo="body" [focusOnShow]="false">
    <form [formGroup]="commentForm">
      <div class="form-group">
        Please describe the changes you are about to make:
        <textarea pInputTextarea formControlName="description" class="form-control" [required]="true"
          style="width: 100%;" autoResize="autoResize" placeholder="Describe..."></textarea>
      </div>
      <div class="form-group" style="width: 100%; text-align: right">
        <p-button type="button" (click)="closeUndoWOCompletion()" label="Cancel" severity="info"></p-button>
        &nbsp;
        <p-button type="button" type="submit" [disabled]="commentForm.invalid || saving" (click)="undoWOCompletion()"
          label="Submit"></p-button>
      </div>
    </form>
  </p-dialog>
  }
</div>
}